const openAiHeaders = {
    'Content-type': 'application/json',
    'Authorization': `Bearer ${process.env.REACT_APP_PUBLIC_OPENAI_API_KEY}`
}

export const createEmbedding = async (textToembedd) => {
    try {
        const response = await fetch(`https://api.openai.com/v1/embeddings`, {
            method: 'POST',
            headers: openAiHeaders,
            body: JSON.stringify({
                'model': 'text-embedding-ada-002',
                'input': textToembedd
            })
        });

        if (response.ok) {
            const data = await response.json();
            return data; // Return the data
        } else {
            console.error('Something in Embedding failed')
        }
    } catch (error) {
        console.error(error)
    }
}